<template>
  <div class="floor-share-container">
    <el-row :gutter="20">
      <el-col :span="4">
        <room-tree-div ref="roomTree" @selectRoom="handleSelectRoom" />
      </el-col>
      <el-col :span="20">
        <el-card class="box-card">
          <div slot="header" class="flex justify-between">
            <span>{{ $t('floorShare.title') }}</span>
            <el-button v-if="floorShareInfo.conditions.floorId || floorShareInfo.conditions.unitId" type="primary" size="small" style="float: right;"
              @click="openAddFloorShareModal">
              {{ $t('common.add') }}
            </el-button>
          </div>

          <el-table :data="floorShareInfo.floorShares" border style="width: 100%" v-loading="loading">
            <el-table-column prop="fsmId" :label="$t('floorShare.id')" align="center" />
            <el-table-column prop="floorNum" :label="$t('floorShare.floor')" align="center" />
            <el-table-column prop="unitNum" :label="$t('floorShare.unit')" align="center">
              <template slot-scope="scope">
                {{ scope.row.unitNum || '-' }}
              </template>
            </el-table-column>
            <el-table-column prop="meterTypeName" :label="$t('floorShare.meterType')" align="center" />
            <el-table-column prop="meterNum" :label="$t('floorShare.meterNum')" align="center" />
            <el-table-column prop="meterPosition" :label="$t('floorShare.meterPosition')" align="center">
              <template slot-scope="scope">
                {{ scope.row.meterPosition || '-' }}
              </template>
            </el-table-column>
            <el-table-column prop="shareTypeName" :label="$t('floorShare.shareType')" align="center" />
            <el-table-column prop="formulaValue" :label="$t('floorShare.formula')" align="center">
              <template slot-scope="scope">
                {{ scope.row.formulaValue || '-' }}
              </template>
            </el-table-column>
            <el-table-column prop="configName" :label="$t('floorShare.feeItem')" align="center" />
            <el-table-column prop="sharePrice" :label="$t('floorShare.feePrice')" align="center" />
            <el-table-column prop="meterRatio" :label="$t('floorShare.meterRatio')" align="center">
              <template slot-scope="scope">
                {{ scope.row.meterRatio ? Number(scope.row.meterRatio).toFixed(2) : '1.00' }}
              </template>
            </el-table-column>
            <el-table-column prop="isDeduction" :label="$t('floorShare.isDeduction')" align="center">
              <template slot-scope="scope">
                <el-tag :type="scope.row.isDeduction === '1' ? 'danger' : 'success'" size="small">
                  {{ scope.row.isDeduction === '1' ? $t('floorShare.isDeductionDeduct') : $t('floorShare.isDeductionAdd') }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="curDegree" :label="$t('floorShare.degree')" align="center" />
            <el-table-column prop="curReadingTime" :label="$t('floorShare.readingTime')" align="center" />
            <el-table-column prop="createTime" :label="$t('floorShare.createTime')" align="center" />
            <el-table-column :label="$t('common.operation')" align="center" width="180">
              <template slot-scope="scope">
                <el-button size="mini" type="primary" @click="openEditFloorShareModal(scope.row)">
                  {{ $t('common.edit') }}
                </el-button>
                <el-button size="mini" type="danger" @click="openDeleteFloorShareModal(scope.row)">
                  {{ $t('common.delete') }}
                </el-button>
              </template>
            </el-table-column>
          </el-table>

          <el-pagination :current-page.sync="page.current" :page-sizes="[10, 20, 30, 50]" :page-size="page.size"
            :total="page.total" layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange"
            @current-change="handleCurrentChange" />
        </el-card>
      </el-col>
    </el-row>

    <add-floor-share ref="addFloorShare" @success="handleSuccess" />
    <edit-floor-share ref="editFloorShare" @success="handleSuccess" />
    <delete-floor-share ref="deleteFloorShare" @success="handleSuccess" />
  </div>
</template>

<script>
import { listFloorShareMeter } from '@/api/fee/floorShareApi'
import RoomTreeDiv from '@/components/room/roomTreeDiv'
import AddFloorShare from '@/components/fee/addFloorShare'
import EditFloorShare from '@/components/fee/editFloorShare'
import DeleteFloorShare from '@/components/fee/deleteFloorShare'
import { getCommunityId } from '@/api/community/communityApi'

export default {
  name: 'FloorShareList',
  components: {
    RoomTreeDiv,
    AddFloorShare,
    EditFloorShare,
    DeleteFloorShare
  },
  data() {
    return {
      loading: false,
      floorShareInfo: {
        floorShares: [],
        conditions: {
          floorId: '',
          communityId: ''
        }
      },
      page: {
        current: 1,
        size: 10,
        total: 0
      }
    }
  },
  created() {
    this.floorShareInfo.conditions.communityId = getCommunityId()
  },
  methods: {
    async listFloorShares() {
      try {
        this.loading = true
        const params = {
          page: this.page.current,
          row: this.page.size,
          communityId: this.floorShareInfo.conditions.communityId
        }
        // 根据选择的类型添加不同的参数
        if (this.floorShareInfo.conditions.unitId) {
          params.unitId = this.floorShareInfo.conditions.unitId
        } else if (this.floorShareInfo.conditions.floorId) {
          params.floorId = this.floorShareInfo.conditions.floorId
        }
        const { data, total } = await listFloorShareMeter(params)
        this.floorShareInfo.floorShares = data
        this.page.total = total
      } catch (error) {
        this.$message.error(this.$t('floorShare.fetchError'))
      } finally {
        this.loading = false
      }
    },
    handleSelectRoom({ roomId, floorId, unitId, floorNum, unitNum }) {
      if (roomId) {
        return
      } else if (unitId) {
        this.floorShareInfo.conditions.unitId = unitId
        this.floorShareInfo.conditions.floorId = floorId || ''
        this.floorShareInfo.conditions.floorNum = floorNum || ''
        this.floorShareInfo.conditions.unitNum = unitNum || ''
      } else if (floorId) {
        this.floorShareInfo.conditions.floorId = floorId
        this.floorShareInfo.conditions.unitId = ''
        this.floorShareInfo.conditions.floorNum = floorNum || ''
        this.floorShareInfo.conditions.unitNum = ''
      }
      this.page.current = 1
      this.listFloorShares()
    },
    openAddFloorShareModal() {
      const params = {
        communityId: this.floorShareInfo.conditions.communityId
      }
      // 根据当前选择的类型传递不同的参数
      if (this.floorShareInfo.conditions.unitId) {
        params.unitId = this.floorShareInfo.conditions.unitId
        params.unitNum = this.floorShareInfo.conditions.unitNum
        params.floorId = this.floorShareInfo.conditions.floorId
        params.floorNum = this.floorShareInfo.conditions.floorNum
        params.type = 'unit'
      } else if (this.floorShareInfo.conditions.floorId) {
        params.floorId = this.floorShareInfo.conditions.floorId
        params.floorNum = this.floorShareInfo.conditions.floorNum
        params.type = 'floor'
      } else {
        this.$message.warning(this.$t('floorShare.selectFloorOrUnit'))
        return
      }
      this.$refs.addFloorShare.open(params)
    },
    openEditFloorShareModal(row) {
      this.$refs.editFloorShare.open(row)
    },
    openDeleteFloorShareModal(row) {
      this.$refs.deleteFloorShare.open(row)
    },
    handleSuccess() {
      this.listFloorShares()
    },
    handleSizeChange(val) {
      this.page.size = val
      this.listFloorShares()
    },
    handleCurrentChange(val) {
      this.page.current = val
      this.listFloorShares()
    }
  }
}
</script>

<style lang="scss" scoped>
.floor-share-container {
  padding: 20px;

  .box-card {
    margin-bottom: 20px;
  }

  .el-pagination {
    margin-top: 20px;
    text-align: right;
  }
}
</style>